export enum BlogTypeEnum {
  active = 'active',
  inactive = 'inactive',
  draft = 'draft',
}

export enum BlogSectionType {
  image = 'image',
  video = 'video',
  text = 'text',
  heading = 'heading',
}
